import { render, staticRenderFns } from "./AddRoleComponent.vue?vue&type=template&id=535fe673&"
import script from "./AddRoleComponent.vue?vue&type=script&lang=js&"
export * from "./AddRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports